// mui
import { Box } from '@mui/material';

function Flag(key, code, sx = {}) {
    const c = code.toLowerCase();
    return (
        <Box
            key={key}
            component='img'
            loading='lazy'
            width='16'
            height='12'
            alt={code}
            src={`https://flagcdn.com/16x12/${c}.png`}
            srcSet={`https://flagcdn.com/32x24/${c}.png 2x, https://flagcdn.com/48x36/${c}.png 3x`}
            sx={sx}
        />
    );
}

function FlagBig(key, code) {
    const c = code.toLowerCase();
    return (
        <Box
            key={key}
            component='img'
            loading='lazy'
            width='32'
            height='24'
            alt={code}
            src={`https://flagcdn.com/32x24/${c}.png`}
            srcSet={`https://flagcdn.com/64x48/${c}.png 2x, https://flagcdn.com/96x72/${c}.png 3x`}
        />
    );
}

export { Flag, FlagBig };
